
import Url from 'url-parse';
import { Modal } from 'bootstrap';

class MultiChoicePlus {
  constructor() {
    $('span.requireOne').each(function (i, grp) {
                    let validators = $(grp).siblings('.validationBox');
                    $(grp).find('input[type="checkbox"]').each((j, box) =>
                        $(box).change(() => setKeyValue($(grp), validators)));


                    validators.each(function (k, validator) {
                        // Set up custom validation message
                        validator.addEventListener('invalid', function (event) {
                            if (event.target.validity.valueMissing) {
                                event.target.setCustomValidity('You must select at least one option.');
                            }
                        });
                        // Remove validation message when input is valid
                        validator.addEventListener('change', function (event) {
                            event.target.setCustomValidity('');
                        });
                    });
                });
  }

	setKeyValue(group, validBox) {
                var checkedCount = group.find('input[type="checkbox"]:checked').length;
                validBox.val(checkedCount == 0 ? '' : checkedCount);
                validBox.get(0).dispatchEvent(new Event('change'));
            }
}

document.addEventListener('DOMContentLoaded', () => {
  new MultiChoicePlus();
})

